// Ticks a promotional countdown once per second toward data-end.
class SCountdown extends HTMLElement {
  #timerId = 0;

  connectedCallback() {
    this.end = new Date(this.dataset.end || '').getTime();
    this.format = this.dataset.format || '{h} h {m} min {s} s';
    if (Number.isNaN(this.end)) return;
    this.#tick();
    this.#timerId = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timerId);
  }

  #tick() {
    const remaining = Math.max(0, this.end - Date.now());
    const hours = Math.floor(remaining / 3.6e6);
    const minutes = String(Math.floor((remaining % 3.6e6) / 6e4)).padStart(2, '0');
    const seconds = String(Math.floor((remaining % 6e4) / 1e3)).padStart(2, '0');
    this.textContent = this.format.replace('{h}', String(hours)).replace('{m}', minutes).replace('{s}', seconds);
    if (remaining === 0) window.clearInterval(this.#timerId);
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
